import React from "react";
import { AppList } from "components/list/AppList";

import { Datagrid, TextField, useTranslate } from "react-admin";

import { ScrollingWrapper } from "../../../components/ScrollingWrapper";
import { DateTimeField } from "../../../components/fields/DateFormatField";
import { OAuth2RequestsFilter } from "./ListFilters";

const defaultSort = { field: "id", order: "DESC" };

export const OAuth2RequestsList = (props) => {
	const t = useTranslate();
	return (
		<AppList
			{...props}
			sort={defaultSort}
			exporter={false}
			bulkActionButtons={false}
			filters={<OAuth2RequestsFilter />}
		>
			<ScrollingWrapper>
				<Datagrid>
					<TextField source="oauth2_client_name" />
					<TextField source="oauth2_token_user_company_name" />
					<TextField source="request_endpoint" />
					<TextField source="request_method" />
					<DateTimeField source="request_registered_at" withLocalTimeZone />
				</Datagrid>
			</ScrollingWrapper>
		</AppList>
	);
};
